"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopTimer = exports.startTimer = void 0;
let timerId;
const startTimer = (callback) => {
    timerId = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
        console.log('time is over');
        yield callback();
    }), 600000); // 10 �����
};
exports.startTimer = startTimer;
const stopTimer = () => {
    clearTimeout(timerId);
    timerId = null;
};
exports.stopTimer = stopTimer;
